import type { Update } from 'vite';

function debounceReload(time: number) {
	let timer: ReturnType<typeof setTimeout> | null;

	return () => {
		if (timer) {
			clearTimeout(timer);
			timer = null;
		}

		timer = setTimeout(() => {
			location.reload();
		}, time);
	};
}

const pageReload = debounceReload(50);

export async function loadHrmUpdateModule(update: Update) {
	const [acceptedPathWithoutQuery, query] = update.acceptedPath.split('?');

	const importPromise = import(
		/* @vite-ignore */
		`${import.meta.env.BASE_URL
		+ acceptedPathWithoutQuery!.slice(1)
		}?${update.explicitImportRequired ? 'import&' : ''}t=${update.timestamp}${
			query ? `&${query}` : ''
		}`
	);

	if (update.isWithinCircularImport) {
		importPromise.catch(() => {
			// eslint-disable-next-line no-console
			console.info(
				`[hmr] ${update.acceptedPath} failed to apply HMR as it's within a circular import. Reloading page to reset the execution order. `
				+ 'To debug and break the circular import, you can run `vite --debug hmr` to log the circular dependency path if a file change triggered it.',
			);

			pageReload();
		});
	}

	return await importPromise;
}
